import { BannerSearchResponse } from '../services/fetchBannerSearch'

// Transforma la respuesta del backend al formato de Contentful
export const adaptBannerToContentfulFormat = (
  banner: BannerSearchResponse | null
) => {
  if (!banner) return null
  return {
    sys: { type: 'Array' },
    total: 1,
    skip: 0,
    limit: 1,
    items: [
      {
        sys: {
          id: banner.entryId,
          type: 'Entry',
          contentType: { sys: { id: 'plpBannerLegal', linkType: 'ContentType', type: 'Link' } }
        },
        fields: {
          imageDesktop: banner.imageDesktop?.url ?? '',
          imageMobile: banner.imageMobile?.url ?? '',
          urlRedirect: banner.urlRedirect,
          creativeName: banner.creativeName,
          creativeSlot: banner.creativeSlot,
          promotionId: banner.promotionId,
          promotionName: banner.promotionName,
          label: banner.label,
          matchMode: banner.matchMode
        }
      }
    ],
    includes: {
      Asset: [],
      Entry: []
    }
  }
}
